import { BaseContainerModel } from "../base-container.model";
import { bl_fi_mst_comp_entity_purchase_credit_limit_RowCLass } from "../../dbschema/bl_fi_mst_comp_entity_purchase_credit_limit.model";

export class CompanyEntityPurchaseCreditLimitsContainerModel extends BaseContainerModel {
  bl_fi_mst_comp_entity_purchase_credit_limits: bl_fi_mst_comp_entity_purchase_credit_limit_RowCLass =
    new bl_fi_mst_comp_entity_purchase_credit_limit_RowCLass();
}
